<template>
    <div class="outside-wrapper after-navbar-spacer">
        <div class="container-fluid">
            <transition name="fade">
            <form v-if="!loading" id="f-event-filters" method="get">
                <div class="row section-filters">
                    <div class="col-12 mt-3">
                        <h2 v-html="header"></h2>
                    </div>

                    <div class="col-md-4">
                        <button class="btn btn-link btn-link-ms collapsed" type="button" v-b-toggle.filter-date>
                            Data
                            <img v-bind:src="getAssetPath('img/icon-arrowhead-down.png')" alt="">
                        </button>

                        <div class="collapse show filter-active-item filter-date-collapse" id="filter-date-active">
                                <span v-if="!selectedDates.length && years.length">
                                    {{ years.length === 1 ? years[0] : `${years[0]} - ${years[years.length - 1]}` }}
                                </span>
                                <span v-for="date in selectedDates" v-html="date" :key="date"></span>
                            </div>

                            <b-collapse class="filter-items filter-date-collapse" id="filter-date">
                                <div class="form-group">
                                    <div class="custom-control custom-checkbox" v-for="year in years" :key="year">
                                        <input type="checkbox" class="custom-control-input" v-bind:id="'year-'+year" v-bind:value="year" v-model="selectedDates">
                                        <label class="custom-control-label" v-bind:for="'year-'+year" v-html="year"></label>
                                    </div>
                                </div>
                        </b-collapse>
                    </div>

                    <div class="col-md-4">
                        <button class="btn btn-link btn-link-ms collapsed" type="button" v-b-toggle.filter-specialty>
                            Specjalizacja
                            <img v-bind:src="getAssetPath('img/icon-arrowhead-down.png')" alt="">
                        </button>

                        <div class="collapse show filter-active-item filter-specialty-collapse" id="filter-specialty-active">
                            <span v-if="!selectedSpecializations.length"> Wszystkie </span>
                            <span v-for="spec in selectedSpecializations" v-html="spec" :key="spec"></span>
                        </div>

                        <b-collapse class="collapse filter-items filter-specialty-collapse" id="filter-specialty">
                            <div class="form-group">
                                <div class="custom-control custom-checkbox" v-for="specialization in specializations" :key="specialization">
                                    <input type="checkbox" class="custom-control-input" v-bind:id="'specialization-'+specialization"
                                        v-bind:value="specialization" v-model="selectedSpecializations">
                                    <label class="custom-control-label" v-bind:for="'specialization-'+specialization" v-html="specialization"></label>
                                </div>
                            </div>
                        </b-collapse>
                    </div>

                    <div class="col-md-4">
                        <div class="input-group mb-3">
                            <input type="text" class="form-control" v-model="searchQuery" @input="debouncedFilter" @keydown.enter.prevent placeholder="Wpisz nazwę wydarzenia" aria-label="Wpisz nazwę wydarzenia" aria-describedby="button-search">
                        </div>
                    </div>
                </div>
            </form>
        </transition>

        <div class="container-fluid">
        <div v-if="loading" class="loader">
            Ładowanie...
            <Spinner class="spinner-margin" :size="50" :line-fg-color="'#223D79'" :line-bg-color="'#ccc'" />
        </div>
        <transition-group name="fade" tag="div" class="row section-events-list" v-else>
                <single-event v-for="event in events" :event="event" :key="event.id + '-' + event.name" :asset_path="asset_path" :withYear="true"></single-event>
        </transition-group>
        <div v-if="!loading && events.length === 0" class="no-events">
            Brak wydarzeń do wyświetlenia.
        </div>
        </div>

            <nav v-if="pagination.last_page > 1" aria-label="stronicowanie">
                <ul class="pagination justify-content-center">
                    <li v-if="page > 1" class="page-item">
                        <a class="page-link" href="#" v-on:click="setPage(page - 1)" aria-label="Poprzednia">
                            <span aria-hidden="true">&laquo;</span>
                        </a>
                    </li>
                    <li v-for="n in pagination.last_page" :class="'page-item' + (n == page ?  ' active ' : '')" aria-current="page">
                        <a class="page-link" href="#" v-on:click="setPage(n)" v-html="n"></a>
                    </li>
                    <li v-if="page < pagination.last_page" class="page-item">
                        <a class="page-link" href="#" v-on:click="setPage(page + 1)" aria-label="Następna">
                            <span aria-hidden="true">&raquo;</span>
                        </a>
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</template>
<script>
import FormInput from "../../../fit2/js/components/formInput";
import Spinner from 'vue-simple-spinner';
import debounce from 'lodash/debounce';

export default {
    components: {
        FormInput,
        Spinner,
    },
    props: ['asset_path', 'ignore_event', 'archived', 'header'],
    created() {
        this.fetchData();
        this.filter();
        this.debouncedFilter = debounce(this.filter, 300);
    },
    data() {
        return {
            selectedDates: [],
            selectedSpecializations: [],
            events: [],
            allEvents: [],
            pagination: [],
            page: 1,
            specializations: [],
            years: [],
            searchQuery: '',
            loading: true
        }
    },
    watch: {
        selectedSpecializations: 'filter',
        selectedDates: 'filter'
    },
    methods: {
        fetchData() {
            axios.get(this.archived ? '/api/fetch/archived' : '/api/fetch')
            .then((response) => {
                this.specializations = response.data.specializations;
                this.years = response.data.years;
                this.selectedDates = [];
                this.filter();
                this.loading = false;
            });
        },
        filter() {
            axios.get(this.archived ? '/api/eventables/archived' : '/api/eventables', {
                params: {
                    ignoreName: this.ignore_event,
                    page: this.page,
                    specializations: this.selectedSpecializations,
                    years: this.selectedDates,
                    searchQuery: this.searchQuery
                }
            })
            .then(response => {
                this.events = response.data.data;
                this.pagination = response.data.meta;
            })
        },
        getAssetPath(path) {
            return this.asset_path + '/' + path;
        },
        setPage(page) {
            this.page = page;
            this.filter();
        }
    }

}

</script>
<style scoped>
.loader {
    text-align: center;
    padding: 50px;
    font-size: 20px;
    color: #333;
}

.spinner-margin {
    margin: 10px 0;
}

.fade-enter-active, .fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
    opacity: 0;
}

.no-events {
    text-align: center;
    padding: 50px;
    font-size: 20px;
    color: #333;
}
</style>